var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2860179",
    filter: "url(#filter0_d_1365_4365)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2860182"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 65",
    cx: 33.5,
    cy: 27.5,
    r: 20.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3195 17.1646C35.3195 16.8557 35.1805 16.5595 34.9331 16.3411C34.6858 16.1227 34.3503 16 34.0004 16C33.6506 16 33.3151 16.1227 33.0677 16.3411C32.8204 16.5595 32.6814 16.8557 32.6814 17.1646V18.038H31.9467C30.5327 18.0379 29.1719 18.5136 28.1412 19.3682C27.1105 20.2228 26.4874 21.3921 26.3988 22.638L26.1073 26.7535C25.9962 28.3227 25.3994 29.8349 24.3821 31.1253C24.1718 31.392 24.0434 31.7023 24.0092 32.0258C23.975 32.3494 24.0363 32.6753 24.187 32.9717C24.3377 33.2682 24.5727 33.5252 24.8693 33.7177C25.1658 33.9103 25.5137 34.0318 25.8792 34.0704L30.3731 34.5456V35.7975C30.3731 36.6468 30.7553 37.4614 31.4355 38.062C32.1158 38.6626 33.0384 39 34.0004 39C34.9625 39 35.8851 38.6626 36.5653 38.062C37.2456 37.4614 37.6278 36.6468 37.6278 35.7975V34.5456L42.1217 34.0693C42.4869 34.0305 42.8346 33.909 43.131 33.7165C43.4273 33.5241 43.6622 33.2672 43.8129 32.9709C43.9636 32.6746 44.0249 32.349 43.9909 32.0255C43.9569 31.7021 43.8287 31.392 43.6188 31.1253C42.6014 29.8349 42.0046 28.3227 41.8935 26.7535L41.602 22.6391C41.5137 21.393 40.8908 20.2234 39.8601 19.3686C38.8294 18.5138 37.4683 18.0379 36.0542 18.038H35.3195V17.1646ZM31.9467 19.7848C31.036 19.7847 30.1595 20.0911 29.4956 20.6415C28.8318 21.1919 28.4305 21.945 28.3734 22.7474L28.0833 26.863C27.9492 28.7507 27.2311 30.5698 26.0071 32.1221C25.9919 32.1414 25.9826 32.1639 25.9801 32.1873C25.9776 32.2107 25.982 32.2342 25.9929 32.2557C26.0038 32.2771 26.0208 32.2957 26.0422 32.3097C26.0637 32.3236 26.0888 32.3324 26.1153 32.3352L31.0445 32.8581C33.0085 33.0654 34.9923 33.0654 36.9564 32.8581L41.8856 32.3352C41.912 32.3324 41.9372 32.3236 41.9586 32.3097C41.98 32.2957 41.997 32.2771 42.0079 32.2557C42.0188 32.2342 42.0232 32.2107 42.0207 32.1873C42.0183 32.1639 42.009 32.1414 41.9937 32.1221C40.7703 30.5697 40.0526 28.7506 39.9189 26.863L39.6274 22.7474C39.5704 21.945 39.1691 21.1919 38.5052 20.6415C37.8413 20.0911 36.9648 19.7847 36.0542 19.7848H31.9467ZM34.0004 37.2532C33.0903 37.2532 32.3516 36.601 32.3516 35.7975V34.9241H35.6492V35.7975C35.6492 36.601 34.9106 37.2532 34.0004 37.2532Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1365_4365",
    x: 0,
    y: 0,
    width: 67,
    height: 67,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.584314 0 0 0 0 0.611765 0 0 0 0 0.882353 0 0 0 0.54 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1365_4365"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1365_4365",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/NotificationIcon.5d9cd46fec5dadd815a04390d914725a.svg";
export { ForwardRef as ReactComponent };